import { useLink } from '@/helpers/url'

let config = {}

export function useConfig() {

    if ( Object.keys(config).length > 0 ) {
        return config
    }

    if ( WP_KEY in window ) {

        for ( const key in window[WP_KEY] ) {

            let value = window[WP_KEY][key]
            if ( key.indexOf('_URL') !== -1 ) {
                value = useLink(value)
            }
            config[key] = value
        }

        return config
    }

    return {}
}

export const WP_KEY = '__WP__'